/* unplugin-vue-components disabled */import script from "./EnergyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EnergyDetail.vue?vue&type=script&setup=true&lang=js"

import "./EnergyDetail.vue?vue&type=style&index=0&id=70337b2c&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70337b2c"]])

export default __exports__